var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrapper"},[_c('div',{ref:"error",staticClass:"field-error",style:({'maxHeight': _vm.maxHeightValue})},[_vm._v(_vm._s(_vm.error ? _vm.error : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }